import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, HelpBlock } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { FormGroup, FormControl, ControlLabel, Checkbox } from 'react-bootstrap';
import FormValidationService from '../../shared/form/FormValidationService';

class RegionForm extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    render() {
        return (
            <div>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(
                        this.props.errors.name
                    )}
                >
                    <ControlLabel>{Translate('region/form/input-label/name')}</ControlLabel>
                    <FormControl
                        autoFocus
                        type="text"
                        name="name"
                        value={this.props.region.name ? this.props.region.name : ''}
                        onChange={this.handleChange}
                        error={this.props.errors.name}
                    />
                    <HelpBlock>{this.props.errors.name}</HelpBlock>
                </FormGroup>

                {this.props.displayIsDiscontinued && (
                    <FormGroup>
                        <Checkbox
                            name="isDiscontinued"
                            checked={
                                this.props.region.isDiscontinued
                                    ? this.props.region.isDiscontinued
                                    : false
                            }
                            onChange={this.handleCheckboxChange}
                        >
                            <span>{Translate('region/form/checkbox-label/is-discontinued')}</span>
                        </Checkbox>
                    </FormGroup>
                )}
            </div>
        );
    }

    handleChange(e: any) {
        let region = this.props.region;
        region[e.target.name] = e.target.value;
        this.changeRegionState(region);
    }

    handleCheckboxChange(e: any) {
        let region = this.props.region;
        region[e.target.name] = e.target.checked;
        this.changeRegionState(region);
    }

    changeRegionState(region: any) {
        this.props.onChange(region);
    }
}

export default RegionForm;
